export const blockIconsHouseholdBathtubNew = (
	<span className='material-symbols-outlined'>bathtub</span>
);
